import { render, staticRenderFns } from "./AuthIndex.vue?vue&type=template&id=061ae064&scoped=true&"
import script from "./AuthIndex.vue?vue&type=script&lang=js&"
export * from "./AuthIndex.vue?vue&type=script&lang=js&"
import style0 from "./AuthIndex.vue?vue&type=style&index=0&id=061ae064&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061ae064",
  null
  
)

export default component.exports